import styled from "styled-components"
import Text from "../../atoms/Text"
import PasswordInput from "./PasswordInput"
import ErrorableInputWrapper from "../common/ErrorableInputWrapper"

const Container = styled.div`
  width: 100%;
`
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const PasswordFieldGroup = ({ password, passwordConfirm, onChangePassword, onChangeConfirm, onBlurPassword, onBlurConfirm,  errorPassword, errorPasswordConfirm, autoComplete }) => {
  return (
    <Container>
      <LabelWrapper>
        <Text as="label" variant="body2" weight="medium">비밀번호</Text>
        <RequiredCircle aria-label="필수 입력 항목" />
      </LabelWrapper>
      <FieldWrapper>
        <ErrorableInputWrapper $error={!!errorPassword} message={errorPassword}>
          <PasswordInput
            name="password"
            placeholder="숫자/영문/특수 문자 조합, 8자 이상"
            value={password}
            onChange={onChangePassword}
            onBlur={onBlurPassword}
            $error={!!errorPassword}
            autoComplete={autoComplete}
          />
        </ErrorableInputWrapper>
        <ErrorableInputWrapper $error={!!errorPasswordConfirm} message={errorPasswordConfirm}>
          <PasswordInput
            name="passwordConfirm"
            placeholder="비밀번호 확인"
            value={passwordConfirm}
            onChange={onChangeConfirm}
            onBlur={onBlurConfirm}
            $error={!!errorPasswordConfirm}
            autoComplete={autoComplete}
          />
        </ErrorableInputWrapper>
      </FieldWrapper>
      
    </Container>
  )
}

export default PasswordFieldGroup
